import { render } from "./TrendingPostsList.vue?vue&type=template&id=383a0691"
import script from "./TrendingPostsList.vue?vue&type=script&lang=js"
export * from "./TrendingPostsList.vue?vue&type=script&lang=js"

import "./TrendingPostsList.vue?vue&type=style&index=0&id=383a0691&lang=css"

import exportComponent from "C:\\wamp64\\www\\wordpress\\wp-content\\themes\\yka-theme-2022\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__